var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.46 30.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".youtube_svg{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "youtube_svg",
    d: "M41.74,3.25C40.07,.14,33.76-.14,21.75,.04,11.5,.2,6.04,.43,4.46,1,2.88,1.57,1.21,2.48,.73,5.4,.25,8.31-.35,14.09,.25,21.98c.6,7.89,4.3,7.74,10.37,8.03,6.07,.29,15.68,.45,22.7,0,7.03-.45,8.7-1.19,9.65-7.07,.96-5.88,.43-16.58-1.24-19.69ZM17.41,21.74V8.65l11.42,6.55-11.42,6.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.289a6cbdddae729a9bcea85be797b69b.svg";
export { ForwardRef as ReactComponent };